import React from "react";
import { Badge } from "reactstrap";
import "../../pages/PlanningMap/index.css";

type SelectedPolygonProps = {
  planningPolygons: Array<any>;
  selectedFeatureIndexes: Array<any>;
  toggleSitePlanningCommentUI: (polygon: any) => void;
  editPlanningPolygon: (polygon: any) => void;
};

const SelectedPolygon = ({
  planningPolygons,
  selectedFeatureIndexes,
  toggleSitePlanningCommentUI,
  editPlanningPolygon,
}: SelectedPolygonProps) => {
  let elementToReturn: Array<any> = [];
  selectedFeatureIndexes.map((selectedFeatureIndex) => {
    const selectedLayerId = selectedFeatureIndex.layer?.id;
    const selectedLayerIdSplitArray = selectedLayerId.split("-");
    const planningPolygonId = parseInt(
      selectedLayerIdSplitArray[selectedLayerIdSplitArray.length - 1],
      10
    );

    // Render elements
    planningPolygons.map((planningPolygon) => {
      if (planningPolygon.properties.id === planningPolygonId) {
        elementToReturn.push(
          <div
            key={`planningPolygon.properties.id-${planningPolygonId}`}
            className="site-planning__right-side-bar__selected-planning-polygon_item"
          >
            <span className="site-planning__right-side-bar__selected-planning-polygon_item__title">
              {planningPolygon.properties.title}
            </span>
            <br />
            <span className="site-planning__right-side-bar__selected-planning-polygon_item__username">{`${planningPolygon.properties.user.first_name} ${planningPolygon.properties.user.last_name}`}</span>
            <br />
            <span className="site-planning__right-side-bar__selected-planning-polygon_item__description">
              {planningPolygon.properties.description}
            </span>
            <br />
            <div className="site-planning__right-side-bar__selected-planning-polygon_item__controls">
              <span
                className="site-planning__right-side-bar__selected-planning-polygon_item__control-button"
                onClick={() => toggleSitePlanningCommentUI(planningPolygon)}
                style={{
                  color: "var(--primary)",
                  fontWeight: 500,
                }}
              >
                <span style={{ marginRight: 6 }}>Nhận xét</span>
                {planningPolygon.properties.site_planning_zone_comment_count >
                  0 && (
                  <Badge color="primary">
                    {
                      planningPolygon.properties
                        .site_planning_zone_comment_count
                    }
                  </Badge>
                )}
              </span>
              <span
                className="site-planning__right-side-bar__selected-planning-polygon_item__control-button"
                onClick={() => editPlanningPolygon(planningPolygon)}
              >
                Sửa
              </span>
              <span
                className="site-planning__right-side-bar__selected-planning-polygon_item__control-button"
                onClick={() => editPlanningPolygon(planningPolygon)}
              >
                Xóa
              </span>
            </div>
          </div>
        );
      }
    });
  });

  let selectedPolygonsElements = null;
  if (elementToReturn.length > 0) {
    selectedPolygonsElements = (
      <div className="site-planning__right-side-bar__selected-planning-polygon">
        <div className="site-planning__sidebar-data-widget__title">
          Khu vực đang chọn
        </div>
        {elementToReturn}
      </div>
    );
  }

  return selectedPolygonsElements;
};

export default SelectedPolygon;
